import React, { useState } from "react";
import { PART_ID } from "MODULES/inventories/constants";
import { AutoCompleteField, Select } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import api from "APP_ROOT/api";
import { Col } from "react-bootstrap";

export default function PartField({ item }) {
  const [selectedPart, setSelectedPart] = useState(null);
  const [alternates, setAlternates] = useState([]);
  const searchParts = filter =>
    api.parts
      .search({
        filter
      })
      .then(resp => resp.data.results);

  const fetchAlternateOptions = part => {
    setSelectedPart(part);
    if (part) {
      api.parts.alternates.search(part.id).then(resp => {
        const vals = resp.data.results;
        const opts = vals.map(val => ({
          text: val.name,
          value: val.id
        }));
        setAlternates(opts);
      });
    }
  };

  return [
    <Col md={2}>
      <Field
        name={`${item}.${PART_ID}`}
        label="Part #"
        placeholder="Type a part's name of ID number..."
        component={AutoCompleteField}
        search={searchParts}
        formatItem={result => result && result.part_number}
        selectedItem={selectedPart}
        onItemSelected={i => i && fetchAlternateOptions(i)}
        required
      />
    </Col>,
    <Col md={2}>
      <Field
        name={`${item}.sell_as_alt_id`}
        component={Select}
        label="Sell As Alternate"
        options={alternates}
      />
    </Col>
  ];
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/ReserveForSale/ConvertDummyForm/PartField.jsx